export const LANGS = ["en", "cn", "bm"];

export const emptyLang = () => ({
  en: "",
  cn: "",
  bm: "",
});

export const parseContent = (content) => {
  if (!content) return {};

  if (typeof content === "string") {
    try {
      return JSON.parse(content);
    } catch {
      return {};
    }
  }

  return content;
};

export const SOCIAL_PLATFORM_OPTIONS = [
  "Discord",
  "Facebook",
  "Instagram",
  "LINE",
  "LinkedIn",
  "RedNote",
  "Telegram",
  "TikTok",
  "WeChat",
  "WhatsApp",
  "X",
  "YouTube",
];